(ns dashboard.core
  (:require
   [reagent.dom :as rdom]
   [re-frame.core :as re-frame]
   [breaking-point.core :as bp]
   [re-pressed.core :as rp]
   [dashboard.events :as events]
   [dashboard.subs :as subs]
   [dashboard.views :as views]
   [dashboard.config :as config]
   [dashboard.router :refer [app-routes route-for]]
   ["@sentry/browser" :as Sentry]))

(defn dev-setup []
  (when config/debug?
    (println (str "[Debug] " config/version))))

(defn prod-setup []
  (when (not config/debug?)
    (do
      (-> Sentry
          (.init #js {:dsn config/sentry-dsn
                      :release (str (if (= config/environment "dev")
                                      "cartier.event-organizer.dev@"
                                      "cartier.event-organizer.pro@") config/version)
                      :environment config/environment}))
      (println (str "[" config/environment "] " config/version)))))

(defn current-page []
  (let [current-route @(re-frame/subscribe [::subs/current-route])]
    (if (some? current-route)
      [(-> current-route :data :view)]
      [views/loading-page])))

;; register route-for due to circular deps
(re-frame/reg-sub
 :route-for
 (fn [db [_ route-key params]]
   (route-for route-key params)))

(defn ^:dev/after-load mount-root []
  (re-frame/clear-subscription-cache!)
  (let [root-el (.getElementById js/document "app")]
    (rdom/unmount-component-at-node root-el)
    (rdom/render [current-page] root-el)))

(defn init []
  (re-frame/dispatch-sync [::events/initialize-db])
  (re-frame/dispatch-sync [::bp/set-breakpoints
                           {:breakpoints [:sm 768
                                          :md 1024
                                          :lg 1280
                                          :xl 1536
                                          :xxl]
                            :debounce-ms 166}])
  (re-frame/dispatch-sync [::rp/add-keyboard-event-listener "keydown"])
  (prod-setup)
  (dev-setup)
  (app-routes)
  (re-frame/dispatch-sync [:boot])
  (mount-root))
